module.exports = __webpack_public_path__ + "0a8ed9bc5d9a7624a50ea7382d5ba12b.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/ui-text-editor/src/fonts/3dprint.ttf?hntrwn
// module id = 403
// module chunks = 0